// extracted by mini-css-extract-plugin
export default {"table_cell":"TemperatureField_table_cell__hvOw5","error_status":"TemperatureField_error_status__aw45I"};